/**
 * FriendCard Component
 * Reusable card component for displaying friend information
 */

import React from 'react';
import { View, Text, Pressable, Platform } from 'react-native';
import { Image } from 'expo-image';
import { isAvatarUrl, getSafeDisplayName } from '../../../src/create/helpers/createUi.helper';
import { FriendAvatar } from '../../friends/shared/FriendAvatar';
import { friendCardStyles as styles } from './FriendCard.styles';
import type { Friend } from '../../../src/friends/types/friends.types';
import { IDLE_COIN_SOURCE } from '../../../constants/assets'
import { WEB_IMAGE_ALT_DECORATIVE } from '../../../src/shared/helpers/imageWebAlt.helper';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';

interface FriendCardProps {
  friend: Friend;
  isSelected: boolean;
  onSelect: () => void;
}

export const FriendCard: React.FC<FriendCardProps> = ({ friend, isSelected, onSelect }) => {
  return (
    <Pressable
      style={({ pressed }) => [
        styles.friendCard,
        isSelected && styles.selectedFriendCard,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.friendCardPressed,
      ]}
      onPress={onSelect}
    >
      <View style={styles.friendInfo}>
        <FriendAvatar
          avatarId={friend.avatarId}
          avatarConfig={friend.avatarConfig}
          fallbackUrl={isAvatarUrl(friend.avatar) ? friend.avatar : undefined}
          size={Platform.OS === 'web' ? 40 : 36}
          nameForInitials={friend.name}
          style={styles.friendAvatarStyle}
        />
        <View style={styles.friendInfoText}>
          <Text style={[styles.friendName, isSelected && styles.friendNameSelected]}>
            {getSafeDisplayName(friend.name)}
          </Text>
          {friend.coins != null && (
            <View style={styles.friendCoinsRow}>
              <Image
                source={IDLE_COIN_SOURCE}
                style={styles.friendCoinIcon}
                alt={WEB_IMAGE_ALT_DECORATIVE}
              />
              <Text style={styles.friendCoinsText}>{friend.coins.toLocaleString()}</Text>
            </View>
          )}
        </View>
      </View>
      {isSelected && (
        <View style={styles.friendSelected}>
          <Text style={styles.friendSelectedText}>✓</Text>
        </View>
      )}
    </Pressable>
  );
};

